import { useState, useEffect } from 'react';
import { getSpecialProductStatus } from '../api';

let cache = null;
let pending = null;

const useSpecialProductStatuses = () => {
  const [statuses, setStatuses] = useState(cache || []);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    if (cache) return;

    if (!pending) {
      pending = getSpecialProductStatus().then(data => {
        cache = data;
        pending = null;
        return data;
      });
    }

    pending.then(data => {
      setStatuses(data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  return { statuses, loading };
};

export default useSpecialProductStatuses;
